import useApiMutation from 'shared/hooks/use-api-mutation';
import {ProductProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useCreateSize = (productId: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: ProductProps) =>
    setData(productsKeys.details(productId), data);

  return useApiMutation<ProductProps>({
    url: `/products/${productId}/sizes`,
    method: 'POST',
    errorTitle: 'Erro ao cadastrar tamanho do produto',
    successTitle: 'Cadastrar tamanho',
    successMessage: 'Tamanho do produto cadastrado com sucesso',
    redirectUrl: (data) => `/menu/products/${data.id}/sizes`,
    onSuccess,
  });
};

export default useCreateSize;
